import { PurchaseModeV2, SaleMode } from '@wix/package-picker-common';
import { Title as TitleUi } from '@wix/package-picker-components';
import * as React from 'react';
import { useQueriesHandler, useQueryParams } from '../../hooks';
import { useSiteGuid } from '../../hooks/useSiteGuid';
import { PackagePickerApiClient, usePackagePickerType } from '../../providers';
import { useAutonomousTranslations } from '../../providers/AutonomousTranslationsProvider';
import { AUTONOMOUS_COMPONENT_NAMES } from '../../types';
const COMPONENT_NAME = AUTONOMOUS_COMPONENT_NAMES.TITLE;
export const Title = _ref => {
  var _offeringQuery$data, _offeringQuery$data2;
  let {
    page = 0,
    children,
    onInit,
    onLoad,
    onError
  } = _ref;
  const {
    packagePickerType
  } = usePackagePickerType();
  const siteGuid = useSiteGuid();
  const {
    isChangePlan
  } = useQueryParams();
  const {
    usePageTitles,
    useOffering
  } = PackagePickerApiClient.hooks;
  const offeringQuery = useOffering({
    packagePickerType,
    siteGuid,
    isChangePlan
  });
  const saleMode = ((_offeringQuery$data = offeringQuery.data) == null ? void 0 : _offeringQuery$data.saleProperties.saleMode) || SaleMode.SeasonalSale;
  const purchaseMode = ((_offeringQuery$data2 = offeringQuery.data) == null ? void 0 : _offeringQuery$data2.purchaseMode) || PurchaseModeV2.InitialPurchase;
  const {
    t
  } = useAutonomousTranslations();
  const pageTitlesQuery = usePageTitles({
    saleMode,
    purchaseMode,
    packagePickerType
  });
  const {
    isSuccess
  } = useQueriesHandler({
    callbacks: {
      onLoad,
      onError,
      onInit
    },
    queries: {
      offeringQuery,
      pageTitlesQuery
    },
    componentName: COMPONENT_NAME
  });
  if (!isSuccess || !pageTitlesQuery.data) {
    return null;
  }
  const titleText = pageTitlesQuery.data.titles.length > page && pageTitlesQuery.data.titles[page].title;
  return /*#__PURE__*/React.createElement(TitleUi, {
    size: "large",
    title: t(titleText)
  }, children);
};
//# sourceMappingURL=Title.js.map